import { useParams } from 'react-router-dom';

const useIsCartOpen = (): boolean => {
  const { id } = useParams<{ id?: string }>();
  return id === 'cart';
};

export default useIsCartOpen;
